export default __webpack_public_path__ + "static/media/iconShopCart.aa1d9a90.svg";